import { useQuery } from "@apollo/react-hooks";
import { MY_TIME_GET_FRAME_PERIOD } from "my-time/graphql/queries";

interface FramePeriodParams {
  contractCode: string;
  year: number;
  month: number;
}

export const useMyTimeFramePeriod = ({
  contractCode,
  year,
  month,
}: FramePeriodParams) => {
  const { data, loading, error } = useQuery(MY_TIME_GET_FRAME_PERIOD, {
    fetchPolicy: "cache-and-network",
    variables: {
      contractCode,
      year,
      month,
    },
  });

  return {
    data: data?.getFramePeriod || {},
    loading,
    error,
  };
};

export default useMyTimeFramePeriod;
